import React, { ReactElement, useEffect, useRef, useState } from 'react';

import { ADHD_SCIENCE_CARDS } from '../../constants';
import * as S from './AdhdScienceCardScroll.styles';


export const AdhdScienceCardScroll = (): ReactElement => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const [canScrollLeft, setCanScrollLeft] = useState<boolean>(false);
  const [canScrollRight, setCanScrollRight] = useState<boolean>(true);

  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number>(0);
  const [scrollLeft, setScrollLeft] = useState<number>(0);

  const updateScrollState = () => {
    const container = scrollRef.current;
    if (container) {
      const newMaxScroll = container.scrollWidth - container.clientWidth;

      const scrollLeft = container.scrollLeft;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < newMaxScroll);
    }
  };

  useEffect(() => {
    updateScrollState();

    const handleResize = () => {
      updateScrollState();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleScroll = () => {
    updateScrollState();
  };


  const startDragging = (e: React.MouseEvent<HTMLDivElement>) => {
    const container = scrollRef.current;
    if (container) {
      setIsDragging(true);
      setStartX(e.pageX - container.offsetLeft);
      setScrollLeft(container.scrollLeft);
    }
  };

  const stopDragging = () => {
    setIsDragging(false);
  };

  const onDragging = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;

    const container = scrollRef.current;
    if (container) {
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 4; // The 4 multiplier adjusts the sensitivity
      container.scrollLeft = scrollLeft - walk;
    }
  };


  return (
    <S.Wrapper>
      <S.ScrollContainer
        ref={scrollRef}
        showLeftFade={canScrollLeft}
        showRightFade={canScrollRight}
        onMouseDown={startDragging}
        onMouseLeave={stopDragging}
        onMouseMove={onDragging}
        onMouseUp={stopDragging}
        onScroll={handleScroll}
      >
        {ADHD_SCIENCE_CARDS.map((item, index) => (
          <S.CardWrapper key={index}>
            <S.Image src={item.imageSrc} />
            <S.BlurImage src="https://cdn.brain.fm/images/science-of-adhd-blur.webp" />
            <S.Header>
              <S.Title>
                {item.title}
              </S.Title>
              <S.Description>
              {item.description}
              </S.Description>
            </S.Header>
          </S.CardWrapper>
        ))}
      </S.ScrollContainer>
    </S.Wrapper>
  );
};
